import script from "./ProfilesGate.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfilesGate.vue?vue&type=script&setup=true&lang=js"

import "./ProfilesGate.vue?vue&type=style&index=0&id=056ad3b0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-056ad3b0"]])

export default __exports__